import { useMemo, useState } from "react";
import { getTravelerLabel } from "../helpers/getTravelerLabel.js";
import { getTravelerError } from "../helpers/getTravelerError.js";
import { DEFAULT_MAX_TRAVELERS } from "../constants.js";
const defaultInitialValues = {
    rooms: 1,
    adults: 1,
    children: 0,
    childrenAges: {},
    lapInfants: 0
};
function useTravelerSelection({ ageSelectEnabled, errorMessage: externalErrorMessage, initialValues = {}, isInternationalFlight, isWhiteLabel, maxTravelers = DEFAULT_MAX_TRAVELERS, shouldCountLapInfant = false, shouldAllowInternationalLapInfants }) {
    const startValues = useMemo(()=>({
            ...defaultInitialValues,
            ...initialValues
        }), [
        initialValues
    ]);
    const [rooms, setRooms] = useState(startValues.rooms);
    const [adults, setAdults] = useState(startValues.adults);
    const [children, setChildren] = useState(startValues.children);
    const [childrenAges, setChildrenAges] = useState(startValues.childrenAges);
    const [lapInfants, setLapInfants] = useState(startValues.lapInfants);
    const [errorMessage, setErrorMessage] = useState('');
    const label = getTravelerLabel({
        adults,
        children,
        lapInfants,
        rooms
    });
    const calculatedErrorMessage = externalErrorMessage ?? getTravelerError({
        children,
        childrenAges,
        lapInfants,
        ageSelectEnabled,
        isInternationalFlight,
        isWhiteLabel,
        shouldAllowInternationalLapInfants
    });
    if (calculatedErrorMessage !== errorMessage) setErrorMessage(calculatedErrorMessage);
    const passengerCount = adults + children + (shouldCountLapInfant ? lapInfants : 0);
    const remainingTravelerCount = Math.max(maxTravelers - passengerCount, 0);
    const removeChildrenAge = (index)=>{
        const remainingAges = Object.fromEntries(Object.entries(childrenAges).filter(([key])=>Number(key) !== index));
        setChildrenAges(remainingAges);
    };
    const onAdultsChange = (count)=>{
        setAdults(count);
        if (count < lapInfants) setLapInfants(count);
    };
    const onChildrenChange = (count)=>{
        setChildren(count);
        removeChildrenAge(count);
    };
    const onAgesChange = (index, value)=>{
        setChildrenAges({
            ...childrenAges,
            [index]: value
        });
    };
    return {
        label,
        errorMessage,
        rooms,
        adults,
        children,
        childrenAges,
        lapInfants,
        remainingTravelerCount,
        setRooms,
        setAdults: onAdultsChange,
        setChildren: onChildrenChange,
        setChildrenAges: onAgesChange,
        setLapInfants
    };
}
export { useTravelerSelection };
